export const gameAttributesSyncedToUi = [
	"alwaysShowCountry",
	"challengeNoRatings",
	"currencyFormat",
	"fantasyPoints",
	"gender",
	"godMode",
	"hideDisabledTeams",
	"homeCourtAdvantage",
	"lid",
	"neutralSite",
	"numPeriods",
	"numWatchColors",
	"phase",
	"quarterLength",
	"season",
	"spectator",
	"startingSeason",
	"teamInfoCache",
	"userTid",
	"userTids",
] as const;
